import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Label, Input, FormFeedback } from 'reactstrap';

import api from "../../../api";
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.saldos.categorias.edit}
                postUrl={api.saldos.categorias.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Categoria ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Categoria"}
                buttonTitle={"Editar Categoria"}
                buttonIcon={"fa fa-pencil fa-lg"}

                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos de la categoria</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" autoFocus data-auto-focus="true"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Saldos/Categorias/Edit.js